// @flow
import type {
  PricingType,
  ProductRequestPayloadType
} from "../../types/pricing.js";

function transformPrice(priceData: any): PricingType {
  return {
    productCode: priceData && priceData.productCode,
    gstInclusivePricing:
      priceData &&
      priceData.cmp &&
      priceData.cmp.PACK1 &&
      priceData.cmp.PACK1.gstInclusive,
    gstExclusivePricing:
      priceData &&
      priceData.cmp &&
      priceData.cmp.PACK1 &&
      priceData.cmp.PACK1.gstExclusive
  };
}

const createProductsRequestPayload = (
  productIds: number[]
): ?Array<ProductRequestPayloadType> => {
  return productIds.map(productId => {
    var productRequest: ProductRequestPayloadType = {
      productCode: productId,
      packs: ["PACK1"]
    };
    return productRequest;
  });
};

const convertToPriceMap = (
  prices: ?Array<PricingType>
): Map<number, PricingType> => {
  prices = prices || [];
  return new Map<number, PricingType>(
    prices.map(price => [price.productCode, price])
  );
};

export async function fetchPricingData(
  postCode: string,
  productIds: number[]
): Promise<Map<number, PricingType>> {
  const data = await (await window.fetch("/trsonline/products/prices/batch", {
    method: "post",
    cache: "no-cache",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      postCode: postCode,
      products: createProductsRequestPayload(productIds)
    })
  })).json();
  const prices = data.prices.map(priceData => transformPrice(priceData));
  return convertToPriceMap(prices);
}
